import Vue from 'vue';
import {$eventBus, EVENT_SHOW_MODAL} from '@common/utils/event.js';

export const $showModal = (component, payload) => {
    $eventBus.$emit(EVENT_SHOW_MODAL, {component, ...payload});
};

Object.defineProperties(Vue.prototype, {
    $showModal: {
        get() {
            return $showModal;
        }
    },
});
